<template>
  <div class="modal fade" id="newOrder">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title text-caps">Add to cart</h4>
                <div class="dialogDismiss">
                  <button type="button" class="close_dialog" data-dismiss="modal"></button>
                </div>
              </div>
              <form action="" @submit.prevent="addToCart">
                <div class="modal-body">
        
                  <div class="row">
                    <div class="col-5">
                      <h5 class="font-bold font-sm">Available Quantity</h5>
                    </div>
                    
                    <div class="col-7">
                      <h5 class="font-bold font-sm">{{availableQty - checkCartQty | formatNumberDec }} <small class="smallFont">tons</small></h5>
                    </div>
                  </div>
                  <div class="row margin_top_md">
                    <div class="col-5">
                      <h5 class="font-bold font-sm">Unit Price</h5>
                    </div>
                    <div class="col-7">
                      <h5 class="font-bold font-sm">₦ {{perTon | formatNumberDec}} <small class="smallForn">per ton</small></h5>
                    </div>
                  </div>
        
                  <div class="row form_row_group margin_top_md">
                    <div class="form_group_item col-md-5">
                      <h4 class="form_row_title font-bold">Quantity</h4>
                      <p class="font-sm color__grey_dark">How much are you buying</p>
                    </div>
                    <div class="form_group_item col-md-7">
                      <div class="inputaffixed inputSurfixed">
                        <div class="inputfixture order-2">
                          <select class="fixtureControl" disabled>
                            <option>Feet</option>
                            <option selected>Tons</option>
                          </select>
                        </div>
                        <input type="number" v-model="quantity" step="any" @keyup="changeValue"
                        class="inputControl form-control-sm form-control order-1" :max="availableQty"
                          placeholder="2,640">
                      </div>
                    </div>
                  </div>
        
                  <div class="row margin_top_md">
                    <div class="col-5">
                      <h5 class="font-bold font-sm">You pay</h5>
                    </div>
                    <div class="col-7">
                      <h5 class="font-bold font-sm">₦ {{nairaValue | formatNumberDec }} </h5>
                    </div>
                  </div>
        
        
                </div>
                <div class="base_divider margin_top_sm"></div>
                <div class="modal-footer">
                  <submit-button type="submit" :disabled="checkField" :loading="loading"
                  class="btn btn-secondary btn-sm caps_upper margin_bottom_sm">
                    Add to cart</submit-button>
                </div>
              </form>
            </div>
          </div>
        </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
export default {
    props: ['farm'],
    data() {
        return {
          nairaValue: '',
          quantity: '',
          loading: false
        }
    },
    computed: {
      ...mapState('offtaker',['cart']),
      checkField() {
        if(this.quantity === '' || 
        Number(this.quantity) > Number(this.availableQty) 
        || Number(this.quantity) === 0 ) {
          return true
        }
        return false
      },
      availableQty() {
        return this.farm ? (this.farm.kg_yield - this.farm.kg_sold) / 1000 : ''
      },
      perTon() {
        return this.farm ? this.farm.agg_kg_price / 0.001 : ''
      },
      checkCartQty() {
        if(this.cart.length !== 0) {
          const arr = this.cart.filter(item => item.id === this.farm.id)
          // console.log('Filter ', arr)
          const total = arr.reduce((sum, item) => {
              return sum + Number(item.quantity)
          }, 0)
          return total;
        } else {
          return 0
        }
      }
    },
    methods: {
      ...mapActions('offtaker', { 
        toCart:'addToCart'
      }),
      changeValue() {
          this.nairaValue = this.quantity * this.farm.agg_kg_price / 0.001
      },
      addToCart() {
        this.saveItem()
        // const obj = {...this.farm}
        // obj.quantity = Number(this.quantity);
        // obj.totalValue = Number(this.nairaValue);
        // obj.cartId = this.cart.length + 1

        // this.toCart(obj)
        // this.quantity = ''
        // this.nairaValue = ''
        // window.$('#newOrder').modal('hide');
        // this.$toastr.success('Added to cart')
        // this.$emit('reCheckQty')
      },
      saveItem() {
        this.loading = true;
        const formData = {
          crop_id: this.farm.id,
          quantity: this.quantity * 1000
        }
        this.$http.post('cart_items', formData)
        .then((response) => {
          this.getCartItems();
        })
        .catch((error) => {
          this.$toastr.error(error)
        })
      },
      getCartItems() {
        this.$http.get('cart_items')
        .then((response) => {
          this.toCart(response.data)
        })
        .catch((error) => {
          this.$toastr.error(error)
        })
        .finally(() => {
          this.loading = false;
          this.quantity = ''
          this.nairaValue = ''
          window.$('#newOrder').modal('hide');
          this.$toastr.success('Added to cart')
        })
      }
    }
}
</script>

<style>

</style>